/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';
var isArguments = function (value) {
  return isType(value, 'Arguments');
};
export default isArguments;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-arguments.js
// module id = 85
// module chunks = 0